import { render, staticRenderFns } from "./note-modal.vue?vue&type=template&id=d9630f02&"
import script from "./note-modal.vue?vue&type=script&lang=ts&"
export * from "./note-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports